import { API_AUTH } from "./common";

const NguonKhachHangApi = {
  combo: () => API_AUTH.get(`nguon-khach-hang/combo`, {}),
  combo1: () => API_AUTH.get(`nguon-khach-hang/combo1`, {}),
  getList: (dbName = null) =>
    API_AUTH.get("api/nguon-khach-hang/DanhSach", { params: { dbName } }),
  getCombo: (dbName = null) => {
    let url = 'api/nguon-khach-hang/combo';
    if (dbName && dbName !== "null") {
      url += `?dbName=${dbName}`;
    }
    return API_AUTH.get(url);
  },
  create: (data, dbName = null) =>
    API_AUTH.post("api/nguon-khach-hang/ThemMoi", data, { params: { dbName } }),
  update: (id, data, dbName = null) =>
    API_AUTH.put("api/nguon-khach-hang/SuaNguonKH", data, { params: { id, dbName } }),
  changeStatus: (id, data, dbName = null) =>
    API_AUTH.put("api/nguon-khach-hang/ChangeStatus", data, { params: { id, dbName } }),
  delete: (id, dbName = null) =>
    API_AUTH.delete("api/nguon-khach-hang/XoaNguonKhachHang", { id, dbName }),
};

export default NguonKhachHangApi;
